import {
  collection,
  getDocs,
  query,
  where,
  FirestoreError,
} from 'firebase/firestore';
import { firestore } from '../../config/firebase';
import { QuizQuestion } from '@e-learning/shared/src/store/types';

/**
 * Fetch questions for a specific course from Firestore
 */
export const fetchQuestionsByCourseId = async (courseId: string): Promise<QuizQuestion[]> => {
  try {
    const questionsRef = collection(firestore, 'questions');
    const q = query(questionsRef, where('courseId', '==', courseId));
    const querySnapshot = await getDocs(q);
    
    const questions: QuizQuestion[] = [];
    querySnapshot.forEach((docSnapshot) => {
      const data = docSnapshot.data();
      questions.push({
        id: docSnapshot.id,
        questionText: data.questionText || '',
        options: data.options || [],
        correctAnswerIndex: data.correctAnswerIndex ?? 0,
        courseId: data.courseId || courseId,
        difficulty: data.difficulty || 'medium',
      } as QuizQuestion);
    });
    
    return questions;
  } catch (error) {
    const firestoreError = error as FirestoreError;
    throw new Error(`Failed to fetch questions: ${firestoreError.message}`);
  }
};

